/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ContractRateKind = typeof ContractRateKind[keyof typeof ContractRateKind];


export const ContractRateKind = {
  regular: 'regular',
  exclusive: 'exclusive',
} as const;
